import { Card, CardContent, CardHeader, Skeleton } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'

export type HistorySkeletonProps = {
  className?: string
}

export const HistorySkeleton = ({ className }: HistorySkeletonProps) => (
  <Card aria-busy="true" aria-label="Loading history" className={cn('w-full', className)} data-sentry-element="Card" data-sentry-component="HistorySkeleton" data-sentry-source-file="history-skeleton.tsx">
    <CardHeader className="gap-3" data-sentry-element="CardHeader" data-sentry-source-file="history-skeleton.tsx">
      <div className="space-y-2">
        <Skeleton className="h-5 w-20" data-sentry-element="Skeleton" data-sentry-source-file="history-skeleton.tsx" />
        <Skeleton className="h-4 w-52" data-sentry-element="Skeleton" data-sentry-source-file="history-skeleton.tsx" />
      </div>
      <div className="flex flex-wrap gap-2">
        <Skeleton className="h-8 w-28" data-sentry-element="Skeleton" data-sentry-source-file="history-skeleton.tsx" />
        <Skeleton className="h-8 w-32" data-sentry-element="Skeleton" data-sentry-source-file="history-skeleton.tsx" />
        <Skeleton className="h-8 min-w-44 flex-1" data-sentry-element="Skeleton" data-sentry-source-file="history-skeleton.tsx" />
      </div>
    </CardHeader>
    <CardContent className="space-y-5 pt-2" data-sentry-element="CardContent" data-sentry-source-file="history-skeleton.tsx">
      {[0, 1, 2].map(section => (
        <div className="space-y-3" key={section}>
          <Skeleton className="h-5 w-36" />
          <Skeleton className="h-20 w-full" />
        </div>
      ))}
    </CardContent>
  </Card>
)
